import { Col, Image, Row } from "antd";
import { useSelector } from "react-redux";
import "./_privacy-policy.scss";
import { useLocation } from "react-router-dom";
import PrivacyPolicy from "./PrivacyPolicy";
import TermsAndConditions from "./TermsAndConditions";

const PrivacyPolicyLayout: React.FC = () => {
  const logo = useSelector((state: any) => state.theme.logoUrl);
  const location = useLocation();

  return <div className="pp-layout">
    {/* Header  */}
    <div className="pp-header">
      <Row align="middle" justify="space-between" className="pp-row">
        <Col>
          <Image preview={false} src={logo} alt="logo" className="pp-header-logo" />
        </Col>
        <Col className="pp-header-text">
          ISO/IEC 27001:2022 Certified
        </Col>
      </Row>
    </div>
    {/* Content */}
    <Row className="pp-content-layout">
      {location.pathname.includes('privacy-policy') && <PrivacyPolicy />}
      {location.pathname.includes('terms-and-conditions') && <TermsAndConditions />}
    </Row>
    {/* Footer */}
    <div className="pp-footer">
      <Row align="middle" justify="end" className="pp-row">
        <Col className="pp-footer-text">All Rights Reserved. Proudly powered by</Col>
        <Col>
          {/* To be replaced with BharatSure logo  */}
          <a href="https://www.bharatsure.com" target="_blank" rel="noopener noreferrer">
            <Image src={'/bharatsure.png'} alt="logo" className="pp-footer-logo" preview={false} />
          </a>
        </Col>
      </Row>
    </div>
  </div>;
};

export default PrivacyPolicyLayout;